import { render, staticRenderFns } from "./ClothPrintLoss.vue?vue&type=template&id=4f0c41ea&lang=html&"
import script from "./ClothPrintLoss.vue?vue&type=script&lang=js&"
export * from "./ClothPrintLoss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports